import { render, staticRenderFns } from "./CancelSubmitForm3.vue?vue&type=template&id=51b10d61&scoped=true"
import script from "./CancelSubmitForm3.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b10d61",
  null
  
)

export default component.exports